import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { EmailSVG } from '@common_components/svg/email.svg';

const EmailIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <EmailSVG/>
    </div>
  );
};

export { EmailIcon };
